import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AdminPanelService } from '../../data/admin-panel.service';
import { EmailCondition, EmailConditionBlock } from '../../data/email-condition';
import { EmailChangerDialogComponent } from './email-changer-dialog/email-changer-dialog.component';

@Component({
    selector: 'app-email-changer',
    templateUrl: './email-changer.component.html',
    styleUrls: ['./email-changer.component.scss']
})
export class EmailChangerComponent implements OnInit {
    conditions: EmailCondition[]
    conditionsWithTitle: EmailConditionBlock[] = [];

    condMap = new Map<string, EmailCondition[]>();

    loadingSpinner = true;

    constructor(
        private dialog: MatDialog,
        protected adminPanelService: AdminPanelService
    ) { }

    ngOnInit(): void {
        this.adminPanelService.getClientsConditions().subscribe(emailCondition => {
            this.conditions = emailCondition;
            this.sortByClazz()
            this.loadingSpinner = false;
        })
    }

    sortByClazz() {
        this.conditions.forEach(cond => {
            if (!this.condMap.has(cond.clazz)) {
                this.condMap.set(cond.clazz, [])
            }

            this.condMap.get(cond.clazz).push(cond)
        })

        this.condMap.forEach((val, key) => {
            this.conditionsWithTitle.push({
                title: this.adminPanelService.dictsMap.get(key),
                conditions: val
            })
        })
    }

    editEmail(condition: EmailCondition, index: number, jindex: number) {
        const dialogRef = this.dialog.open(EmailChangerDialogComponent, {
            data: {
                condition
            },
            panelClass: 'email-changer-dialog'
        });

        dialogRef.afterClosed().subscribe(newCond => {
            if (newCond && newCond instanceof EmailCondition) {
                this.conditionsWithTitle[index].conditions[jindex] = newCond
            }
        })
    }
}

